module.exports = __webpack_public_path__ + "static/img/hb_6-min.46d3ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_6-min.png
// module id = hM48
// module chunks = 1